'use es6';
/**
 * Occurs when a bootstrap grid row's width does not sum to 12
 * @type {String}
 */

export const INVALID_TOTAL_WIDTH = 'INVALID_TOTAL_WIDTH';
export const REFERENCES_TO_RAW_RESOURCE = 'REFERENCES_TO_RAW_RESOURCE';
export const REFERENCES_TO_COMBINED_CSS = 'REFERENCES_TO_COMBINED_CSS';